// src/components/Footer.jsx
import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container" role="contentinfo">
      <div className="footer-content">
        <img
          src="/ll_logo.png" // Assumes logo.png in public/
          alt="LingoLab Logo"
          className="footer-logo"
          onError={(e) => {
            e.target.src = "/fallback-logo.png"; // Fallback image
            e.target.alt = "LingoLab Fallback Logo";
          }}
        />
        <p className="footer-text">© LingoLab 2025</p>
      </div>
    </footer>
  );
};

export default Footer;
